import { render } from "./ResultExpData.vue?vue&type=template&id=db428aa8&scoped=true"
import script from "./ResultExpData.vue?vue&type=script&lang=js"
export * from "./ResultExpData.vue?vue&type=script&lang=js"

import "./ResultExpData.vue?vue&type=style&index=0&id=db428aa8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db428aa8"]])

export default __exports__